import chromeIcon from '../assets/chrome_icon.svg'
import chromeScene from '../assets/chrome_scene.png'
import { defineMessages, useIntl } from 'react-intl'
import { FeatureSection } from '../../FeatureSection'
import { GOOGLE_STORE_URL } from 'src/constants/chromeBot'
import ExternalLinkButton from 'src/Components/shared/ExternalLinkButton'

import styles from './ChromebotFeatureSection.module.scss'

export const MSG = defineMessages({
  chromeAlt: {
    id: 'HomeSearch.featureSection.chromeAlt',
    defaultMessage: 'Chrome icon',
  },
  chromeTitle: {
    id: 'HomeSearch.search.feature.chromeBot.title',
    defaultMessage: 'Do you use Google Chrome?',
  },
  chromeDesc: {
    id: 'HomeSearch.search.feature.chromeBot.description',
    defaultMessage:
      'Take Homebot’s simple, smart financial insights with you on other search sites.',
  },
  chromeCta: {
    id: 'HomeSearch.search.feature.chromeBot.cta',
    defaultMessage: 'Get free extension',
  },
  sceneAlt: {
    id: 'HomeSearch.search.feature.chromeBotImage.altText',
    defaultMessage: 'Man and woman using Homebot on a laptop',
  },
})

export const ChromebotFeatureSection = () => {
  const intl = useIntl()

  return (
    <div className={styles.chromeBotWrapper}>
      <img
        src={chromeScene}
        className={styles.chromeBotImage}
        alt={intl.formatMessage(MSG.sceneAlt)}
      />
      <div className={styles.chromeBotFeature}>
        <FeatureSection
          className={styles.chromeBotFeatureSection}
          title={intl.formatMessage(MSG.chromeTitle)}
          description={intl.formatMessage(MSG.chromeDesc)}
          img={<img src={chromeIcon} alt={intl.formatMessage(MSG.chromeAlt)} />}
        />
        <ExternalLinkButton
          primary
          href={GOOGLE_STORE_URL}
          className={styles.chromeBotButton}
        >
          {intl.formatMessage(MSG.chromeCta)}
        </ExternalLinkButton>
      </div>
    </div>
  )
}
